// eslint-disable-next-line no-restricted-imports
import { FlexContainer, Image } from "@carrotfertility/carotene" // please do not import from @carrotfertility/carotene after eslint rule added on 3/20/25
import React from "react"
import chatSelectionImage from "./resources/illo-benefit-chat-language-selection.png"
import chatSelectionImage2x from "./resources/illo-benefit-chat-language-selection-2x.png"

export const TalkToCarrotMultilingualImage = (): JSX.Element => {
  return (
    <FlexContainer
      width="100%"
      maxHeight="336px"
      background="lightBlue"
      borderRadius="8px"
      justifyContent="center"
      alignItems="center"
      paddingTopBottom="10%"
    >
      <Image
        src={chatSelectionImage}
        srcSet={chatSelectionImage2x}
        altText=""
        width="52%"
        height="74%"
        sx={{ maxInlineSize: "312px", maxBlockSize: "250px" }}
      />
    </FlexContainer>
  )
}
